import React from "react";
import { createRoot } from "react-dom/client";
import StackWarsPage from "../games/stack-wars/GamePage.js";
import TicTacToePage from "../games/tic-tac-toe/GamePage.js";
import MemoryMatchPage from "../games/memory-match/GamePage.js";
import GameRoutePage from "./GameRoutePage.js";
import LogoPreviewPage from "./LogoPreviewPage.js";
import LadooPage from "../games/ladoo/GamePage.js";
import BattleshipPage from "../games/battleship/GamePage.js";
import MisterGamesPage from "./MisterGamesPage.js";
import HomepageMockups from "./HomepageMockups.js";
import "./site.css";
import "../games/ladoo/styles.css";
import "../games/stack-wars/styles.css";
import "../games/battleship/styles.css";
import "../games/tic-tac-toe/styles.css";
import "../games/memory-match/styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

function AppRouter() {
  const path = window.location.pathname.replace(/\/$/, "") || "/";

  if (path === "/stack-wars") {
    return <GameRoutePage title="Stack Wars" description="Drop, connect, and outsmart your rival in local play." GameComponent={StackWarsPage} />;
  }

  if (path === "/tic-tac-toe") {
    return <GameRoutePage title="Tic-Tac-Toe" description="The classic 3-in-a-row duel. Play solo or against a friend." GameComponent={TicTacToePage} />;
  }

  if (path === "/memory-match") {
    return <GameRoutePage title="Memory Match" description="Flip cards, find pairs, beat your best time." GameComponent={MemoryMatchPage} />;
  }

  if (path === "/logo-preview") {
    return <LogoPreviewPage />;
  }

  if (path === "/mockups") {
    return <HomepageMockups />;
  }

  if (path === "/ladoo") {
    return <GameRoutePage title="Ladoo" description="Roll the dice, race your tokens, and send opponents back to base!" GameComponent={LadooPage} />;
  }

  if (path === "/battleship") {
    return <GameRoutePage title="Battleship Wars" description="Place your fleet and sink the enemy before they sink you!" GameComponent={BattleshipPage} />;
  }

  return <MisterGamesPage />;
}

createRoot(root).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);